import React from "react";
import { useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import * as Yup from "yup";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import SelectInput from "../../../components/UI/SelectInput/SelectInput";
import { funcionalidades } from "../../../context/AuthContext";
import { apiRoutes } from "../../../hooks/apiClient";

const columns = [
  {
    name: "Livro Fiscal",
    selector: "nomeLivroFiscal",
    maxWidth: "50%",
    sortable: true,
  },
  {
    name: "Categoria",
    selector: "categoria",
    maxWidth: "50%",
    sortable: true,
  },
];

const validationSchema = Yup.object().shape({ TipoCategoria: Yup.string().default("") });

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  initialValues[key] = "";
});

const ConsultaLivroFiscal = ({ history, match }) => {
  const formik = useFormik({ initialValues, validationSchema });

  return (
    <PaginatedView
      title="Livro Fiscal"
      keyField="sqLivroFiscal"
      descriptionField="nomeLivroFiscal"
      defaultSearch
      defaultSearchPlaceholder="Digite o Nome"
      queryService={apiRoutes.fiscalizacao.parametrizacao.consultaLivroFiscal}
      deleteService={apiRoutes.fiscalizacao.parametrizacao.excluiLivroFiscal}
      editRoute={`${match.url}/form`}
      columns={columns}
      advancedSearchFormik={formik}
      advancedSearchFormikInitialValues={initialValues}
      permissionDelete={funcionalidades.livroFiscal.deletar}
      permissionInsert={funcionalidades.livroFiscal.inserir}
      history={history}
      reduxKey="livrosFiscais"
    >
      <Row>
        <Form.Group as={Col} sm={12} md={6}>
          <Form.Label>Categoria</Form.Label>
          <SelectInput
            formik={formik}
            field="TipoCategoria"
            options={[
              { key: "0", value: "", text: "Selecione" },
              { value: "LF", text: "Livros Fiscais" },
              { value: "NF", text: "Notas Fiscais e/ou equivalentes" },
              { value: "DI", text: "Outros Documentos de Interesse do Fisco" },
              { value: "AM", text: "Arquivos Magneticos" },
            ]}
          />
        </Form.Group>
      </Row>
    </PaginatedView>
  );
};

export default ConsultaLivroFiscal;
